import { render } from "./ScheduleDetailsSetupTableEmptyState.vue?vue&type=template&id=6ba7aa72"
import script from "./ScheduleDetailsSetupTableEmptyState.vue?vue&type=script&lang=js"
export * from "./ScheduleDetailsSetupTableEmptyState.vue?vue&type=script&lang=js"

import "./ScheduleDetailsSetupTableEmptyState.vue?vue&type=style&index=0&id=6ba7aa72&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__